import React, { useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layouts/Header";
import Navbar from "../layouts/Navbar";
import Swal from "sweetalert2";
import ImageFreeCropper from "../crop_image/ImageFreeCropper";

function EtikAdd() {
    const navigate = useNavigate();

    const [formValue, setFormValue] = useState({
        foto: null,
        dokumen: null,
        deskripsi: "",
    });

    const [preview, setPreview] = useState({
        foto: null,
        dokumen: null,
    });

    const [cropData, setCropData] = useState({
        isOpen: false,
        imageSrc: null,
        imageType: "",
    });

    const [croppedImage, setCroppedImage] = useState(null);

    // === OPEN IMAGE CROPPER ===
    const openCropper = (file, imageType) => {
        const reader = new FileReader();
        reader.onload = () => {
            setCropData({
                isOpen: true,
                imageSrc: reader.result,
                imageType,
            });
        };
        reader.readAsDataURL(file);
    };

    const closeCropper = () => {
        setCropData({
            isOpen: false,
            imageSrc: null,
            imageType: "",
        });
        setCroppedImage(null);
    };

    const handleCropped = (file, previewURL) => {
        setFormValue((prev) => ({
            ...prev,
            foto: file,
        }));

        setPreview((prev) => ({
            ...prev,
            foto: previewURL,
        }));
    };

    // === HANDLE INPUT CHANGE ===
    const handleChange = (event) => {
        const { name, value, files } = event.target;

        if (files && files.length > 0) {
            const file = files[0];

            if (files && files.length > 0) {
                const file = files[0];

                // === Jika dokumen, wajib PDF ===
                if (name === "dokumen") {
                    if (file.type !== "application/pdf") {
                        Swal.fire("Error", "File dokumen wajib PDF", "error");
                        return;
                    }

                    const blobUrl = URL.createObjectURL(file);
                    setFormValue((prev) => ({ ...prev, dokumen: file }));
                    setPreview((prev) => ({ ...prev, dokumen: blobUrl }));
                    return;
                }

                // === Jika foto, baru buka cropper ===
                if (name === "foto") {
                    openCropper(file, "foto");
                }
            }
        } else {
            setFormValue((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    // === HANDLE SUBMIT ===
    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!formValue.foto || !formValue.dokumen || !formValue.deskripsi) {
            Swal.fire({
                title: "Error",
                text: "Semua field harus diisi",
                icon: "error",
            });
            return;
        }

        const formData = new FormData();
        formData.append("foto", formValue.foto);
        formData.append("dokumen", formValue.dokumen);
        formData.append("deskripsi", formValue.deskripsi);

        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            await axios.post(`${process.env.REACT_APP_API_URL}/etik/createKodeEtik`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    authorization: token,
                },
            });

            Swal.fire({
                title: "Success",
                text: "Data berhasil ditambah",
                icon: "success",
            });

            navigate("/etik");
        } catch (error) {
            const msg = error.response?.data?.message || "Data gagal ditambah";
            Swal.fire({
                title: "Error",
                text: msg,
                icon: "error",
            });
        }
    };

    return (
        <div className="wrappern">
            <Header />
            <Navbar />

            <div className="content-wrapper">
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Kode Etik</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item">
                                        <Link className="text-decoration-none" to="/">
                                            Administrasi
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active">Kode Etik</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Tambah Kode Etik</h3>
                                    </div>

                                    <div className="card-body">
                                        <form onSubmit={handleSubmit}>
                                            {/* Foto  */}
                                            <div className="form-group">
                                                <label>Foto</label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    name="foto"
                                                    accept="image/*"
                                                    onChange={handleChange}
                                                />
                                                {preview.foto && (
                                                    <img
                                                        src={preview.foto}
                                                        alt="Foto"
                                                        style={{
                                                            maxWidth: "200px",
                                                            marginTop: "10px",
                                                            borderRadius: "5px",
                                                        }}
                                                    />
                                                )}
                                            </div>

                                            {/* Dokumen PDF */}
                                            <div className="form-group">
                                                <label>Dokumen (PDF)</label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    name="dokumen"
                                                    accept="application/pdf"
                                                    onChange={handleChange}
                                                />
                                                {formValue.dokumen && (
                                                    <div className="mt-2">
                                                        <p className="mb-1">
                                                            File: <b>{formValue.dokumen.name}</b>
                                                        </p>
                                                        <a
                                                            href={preview.dokumen}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-sm btn-outline-info"
                                                        >
                                                            Lihat Dokumen
                                                        </a>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Deskripsi */}
                                            <div className="form-group">
                                                <label>Deskripsi</label>
                                                <textarea
                                                    className="form-control"
                                                    name="deskripsi"
                                                    placeholder="Masukkan deskripsi"
                                                    value={formValue.deskripsi}
                                                    onChange={handleChange}
                                                    rows="3"
                                                />
                                            </div>

                                            {/* Tombol */}
                                            <div className="mt-3">
                                                <button type="submit" className="btn btn-info">
                                                    Simpan
                                                </button>
                                                <Link to="/etik">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary ml-2"
                                                    >
                                                        Batal
                                                    </button>
                                                </Link>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {cropData.isOpen && (
                <ImageFreeCropper
                    imageSrc={cropData.imageSrc}
                    setCroppedImage={(file, previewURL) => {
                        handleCropped(file, previewURL);
                        closeCropper();
                    }}
                    onClose={closeCropper}
                />
            )}
        </div>
    );
}

export default EtikAdd;
